import Banner from 'molecules/banner'
import AwardsBanner from '../../assets/awards/AwardsBanner.jpg'
const AwardBanner = () => {
  return (
    <>
      <Banner
        bannerImage={AwardsBanner} 
        />
    </>
  )
}

export default AwardBanner
